import CryptoJS from "crypto-js";
import { useFailMsgBox } from "@/hooks/common/msg-box/useFailMsgBox";
const rawKey = 'ETHm7/6T)8pdheK}jSvbR}(ctreRo/2A'
/**
 * aes cbc 加密
 * @param {string} str -  需要加密的字符串
 * @returns {string} 加密后的字符串
 */
export function encryptionCBC(str, key, iv) {
  const keyHex = CryptoJS.enc.Utf8.parse(key);

  const ivHex = CryptoJS.enc.Utf8.parse(iv);

  const srcs = CryptoJS.enc.Utf8.parse(str);

  const encrypted = CryptoJS.AES.encrypt(srcs, keyHex, {
    iv: ivHex,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypted.toString();
}


function padKeyTo32(keyStr) {
  if (!keyStr) {
    keyStr = '';
  }
  // 先按字符长度补全/截断 (与Java padKey逻辑相同)
  return keyStr.length >= 32 ? keyStr.substring(0, 32) : keyStr.padEnd(32, '0');
}

// 将任意字符串密钥转换为32字节Uint8Array (密钥材料)
function get32ByteKeyMaterial(rawKey) {
  const padded32Str = padKeyTo32(rawKey);          // 先变成32个字符的字符串(ASCII)
  const encoder = new TextEncoder();
  return encoder.encode(padded32Str);               // 返回32字节 (因为补位用的'0'和原始密钥限ASCII)
}

// 随机12字节IV
function generateRandomIV() {
  return crypto.getRandomValues(new Uint8Array(12));
}

function combineIvAndCiphertext(iv, ciphertext) {
  const combined = new Uint8Array(iv.length + ciphertext.length);
  combined.set(iv, 0);
  combined.set(ciphertext, iv.length);
  return combined;
}

function uint8ArrayToBase64(bytes) {
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}
// 加密
export async function encryptData(plainText) {
  // 生成随机IV（16字节）
  const keyMaterial = get32ByteKeyMaterial(rawKey);
  const cryptoKey = await crypto.subtle.importKey(
    'raw', keyMaterial, { name: 'AES-GCM', length: 256 }, false, ['encrypt']
  );
  const iv = generateRandomIV();
  const encoder = new TextEncoder();
  const plainData = encoder.encode(plainText);
  console.log('plainData',plainData)
  const cipherBuffer = await crypto.subtle.encrypt(
    { name: 'AES-GCM', iv: iv, tagLength: 128 },
    cryptoKey,
    plainData
  );

  const cipherBytes = new Uint8Array(cipherBuffer);
  const combined = combineIvAndCiphertext(iv, cipherBytes);
  console.log('加密后密码',uint8ArrayToBase64(combined))
  return uint8ArrayToBase64(combined);


}

// iv随机生成
// plainText 需要加密的字符串
// secretKey 密钥
// export function encryptData(plainText) {
//   // 生成随机IV（16字节）
//   const iv = CryptoJS.lib.WordArray.random(16);

//   // 加密
//   const encrypted = CryptoJS.AES.encrypt(
//     plainText,
//     CryptoJS.enc.Utf8.parse(secretKey),
//     {
//       iv: iv,
//       mode: CryptoJS.mode.CBC,
//       padding: CryptoJS.pad.Pkcs7
//     }
//   );
//   // 返回 IV + 密文的Base64
//   return iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64);
// }

// 处理消息码
export function handleMsgCode(errorCode, mapData) {
  if (errorCode) {
    useFailMsgBox(mapData[errorCode] ? mapData[errorCode] : "unknown error!");
  }
}
